type GadHeaderRowProps = {
  headerText: { key: number; value: string }[];
};

export function GadHeaderRow({ headerText }: GadHeaderRowProps) {
  return (
    <div className="gad-header-row">
      <div className="gad-header-spacer" />
      <div className="gad_option_container" aria-hidden="true">
        {headerText.map((heading) => {
          return (
            <div className="gad-header" key={heading.key}>
              <span>{heading.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
